<template>
  <v-container fluid class="tp-page">
    <template v-if="!addUser">
      <!-- Cabeçalho -->
      <div class="tp-page-head">
        <div>
          <h1 class="tp-page-title">Beneficiários</h1>
          <p class="tp-page-sub">{{ beneficiarios.length }} no total</p>
        </div>
        <div class="tp-head-actions">
          <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" placeholder="Buscar…" hide-details dense outlined color="#00695C" class="tp-search"></v-text-field>
          <v-tooltip bottom v-if="user && user.igrejaId && user.igrejaId !== '6390de5538a3bc18300a2022'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="#00695C" outlined depressed rounded v-on="on" v-bind="attrs" @click="abrirLinkPublico('/acao-social')">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </template>
            <span>Abrir link público de inscrição (Ação Social)</span>
          </v-tooltip>
          <v-btn color="#00695C" dark depressed rounded class="tp-btn-add" @click="criarNovo">
            <v-icon left>mdi-plus-circle-outline</v-icon>Cadastrar
          </v-btn>
        </div>
      </div>

      <v-row>
        <v-col cols="12" sm="12" md="6">
          <v-select outlined dense v-model="programaId" :items="programas" item-text="nome" item-value="id"
            label="Selecione o Programa" @input="carregaBeneficiarios()" color="#00695C"></v-select>
        </v-col>
      </v-row>

      <!-- Tabela -->
      <v-card class="tp-card" elevation="0">
        <v-data-table :search="search" :headers="headers" :items="beneficiarios" sort-by="nome">
          <template v-slot:[`item.action`]="{ item }">
            <v-icon small class="mr-3" color="#00695C" @click="editItem(item)">edit</v-icon>
            <v-icon small color="error" class="mr-3" @click="deleteItem(item)" v-if="user.tipo == 'ADMIN' || user.tipo == 'GERENTE'">delete</v-icon>
            <v-icon small color="#00695C" @click="seeItem(item)">mdi-eye</v-icon>
          </template>
          <template v-slot:no-data>
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Nenhum cadastro encontrado</v-alert>
          </template>
          <template slot="no-results">
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Sua pesquisa por "{{ search }}" não trouxe resultados</v-alert>
          </template>
          <template v-slot:[`item.createdFormatted`]="{ item }">
            <td>{{ item.createdFormatted }}</td>
          </template>
          <template v-slot:[`item.idade`]="{ item }">
            <td>{{ item.idade }} anos</td>
          </template>
          <template v-slot:[`item.dataInicioPrograma`]="{ item }">
            <td>{{ item.dataInicioPrograma }}</td>
          </template>
          <template v-slot:[`item.dataFimPrograma`]="{ item }">
            <td>{{ item.dataFimPrograma }}</td>
          </template>
        </v-data-table>
      </v-card>
    </template>

    <v-card v-else class="tp-card tp-form" elevation="0">
      <v-card-title>
        <span class="tp-serif" style="font-size:1.25rem;color:#00253E;font-weight:600">{{ formTitle }}</span>
        <v-spacer></v-spacer>
        <p style="font-size:13px; color:#00695C; margin:0"> *Busque o membro por CPF ou Nome</p>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row dense v-if="editedIndex === -1">
            <v-col cols="12" sm="12" md="8" lg="8">
              <v-autocomplete v-model="membroSelecionado" :items="membrosRecadastrados" item-text="nome" item-value="id"
                label="Selecione o Membro" outlined color="#00695C" dense :loading="isLoading" :disabled="isLoading"
                return-object @change="selecionarMembroAutocomplete" clearable :filter="customFilter"
                :no-data-text="isLoading ? 'Carregando membros...' : 'Nenhum membro recadastrado encontrado'">
                <template v-slot:item="data">
                  <template v-if="data.item">
                    <div>
                      <strong>{{ data.item.nome }}</strong> <span style="font-size:12px; color:#888">(CPF: {{
                        data.item.cpf }}, Célula: {{ nomeCelula(data.item.celulaId) }})</span>
                    </div>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row dense v-if="membroEncontradoMensagem">
            <v-col cols="12">
              <v-alert dense text :type="membroEncontradoSucesso ? 'info' : 'error'">
                {{ membroEncontradoMensagem }}
              </v-alert>
            </v-col>
          </v-row>

          <v-row dense v-if="editedItem.membroId || editedIndex > -1">
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-text-field v-model="editedItem.nome" outlined label="Nome do Beneficiário" color="#00695C" dense
                disabled></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-text-field v-model="editedItem.cpf" outlined label="CPF do Beneficiário" color="#00695C" dense
                disabled></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-select v-model="editedItem.celulaId" outlined label="Célula" color="#00695C" :items="celulas"
                item-text="nome" item-value="id" dense disabled></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-text-field v-model="editedItem.dataInicioPrograma" label="Início de Participação" outlined
                color="#00695C" v-mask="'##/##/####'" dense required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-text-field v-model="editedItem.dataFimPrograma" label="Término de Participação" outlined
                color="#00695C" v-mask="'##/##/####'" dense required></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn color="#00695C" text large @click="closeAddEdit">Cancelar</v-btn>
        <v-btn color="#00695C" dark depressed rounded large class="tp-btn-add px-6" @click='saveBeneficiary'
          :disabled="!editedItem.membroId && editedIndex === -1">Salvar</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog" max-width="350px">
      <v-card class="tp-card" elevation="0">
        <v-card-title style="justify-content: center; padding: 8px;">
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                <p class="texto tp-serif" style="color:#00253E">Realizar checkin manual</p>
              </v-col>
              <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                <p class="texto">Nome: {{ nome }}</p>
              </v-col>
              <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                <p class="texto">Código: {{ checkin.cod_incricao }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="margin-top: -32px;padding: 20px 5px 0px;">
          <v-container fluid grid-list-md>
            <v-layout row wrap justify-center>
              <v-flex xs6 sm6 lg6>
                <v-btn :loading="loading" dark depressed block color="#00695C" style="border-radius: 7px;" large
                  @click="realizaCheckin">Validar</v-btn>
              </v-flex>
              <v-flex xs6 sm6 lg6>
                <v-btn dark depressed block color="error" style="border-radius: 7px;" large
                  @click="close">Fechar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoDadosInscricao" max-width="1000px" scrollable>
      <v-card class="tp-card" elevation="0">
        <v-card-title>
          <span class="tp-serif" style="font-size:1.25rem;color:#00253E;font-weight:600">FICHA DO BENEFICIÁRIO</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12" sm="12" md="12" lg="12">
                <p style="margin-bottom: 5px">Informações da inscrição</p>
                <v-divider />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#00695C" dense hide-details
                  :readonly="true"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3">
                <v-text-field v-model="editedItem.dataNascimento" label="Data de Nascimento" outlined color="#00695C"
                  v-mask="'##/##/####'" dense hide-details :readonly="true"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3">
                <v-text-field v-model="editedItem.idade" label="Idade" outlined color="#00695C" dense hide-details
                  :readonly="true"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-text-field v-model="editedItem.celula" outlined label="Célula" color="#00695C" dense hide-details
                  :readonly="true"></v-text-field>
              </v-col>
              <v-divider />
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.dataInicioPrograma" label="Início de Participação" outlined dense
                  readonly></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.dataFimPrograma" label="Término de Participação" outlined dense
                  readonly></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="#00695C" text large @click="dialogoDadosInscricao = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { baseApiUrl } from '@/global'
import Snackbar from '../componentes/snackbar.vue'
import moment from 'moment'
import axios from 'axios'
import PH from 'print-html-element'
import { mapState } from 'vuex'
import { mask } from 'vue-the-mask'

export default {
  components: {
    Snackbar,
    Loading,
  },
  directives: { mask },
  data: () => ({
    dialogoDadosInscricao: false,
    programaId: '',
    programaIdAtual: '',
    fullPage: true,
    isLoading: false,
    loading: false,
    search: '',
    nome: '',
    addUser: false,
    dialog: false,
    checkin: {
      cod_incricao: '',
      tipo: '',
      programaId: '',
      userValidatorId: '',
    },
    sexos: [
      { text: 'Masculino', value: 'M' },
      { text: 'Feminino', value: 'F' }
    ],

    headers: [
      { text: 'Nome', align: 'start', value: 'nome', },
      { text: 'CPF', value: 'cpf' },
      { text: 'Célula', value: 'celula' },
      { text: 'Início de Participação', value: 'dataInicioPrograma' },
      { text: 'Término de Participação', value: 'dataFimPrograma' },
      { text: 'Ações', value: 'action', align: 'center', sortable: true },
    ],
    editedIndex: -1,
    editedItem: {
      id: null,
      nome: '',
      cpf: '',
      sexo: '',
      dataNascimento: '',
      celulaId: '',
      dataInicioPrograma: '',
      dataFimPrograma: '',
      membroId: null,
      membro: null
    },
    defaultItem: {
      id: null,
      nome: '',
      cpf: '',
      sexo: '',
      dataNascimento: '',
      celulaId: '',
      dataInicioPrograma: '',
      dataFimPrograma: '',
      membroId: null,
      membro: null
    },
    programas: [],
    beneficiarios: [],
    celulas: [],
    membroEncontradoMensagem: '',
    membroEncontradoSucesso: false,
    membrosRecadastrados: [],
    membroSelecionado: null,
  }),

  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
    user: state => state.userObj,
    companyobj: state => state.companyObj,
    formTitle() {
      return this.editedIndex === -1 ? 'ADICIONAR BENEFICIÁRIO' : 'EDITAR BENEFICIÁRIO'
    }
  }),

  mounted() {
    this.carregaCelulas();
    this.carregaDados();
    this.$watch('programaId', (novo) => {
      if (novo) this.carregaBeneficiarios();
    });
  },

  methods: {
    abrirLinkPublico(rota) {
      const id = this.user && this.user.igrejaId ? this.user.igrejaId : ''
      if (id) window.open(`${window.location.origin}${rota}?igrejaId=${id}`, '_blank')
    },

    async printItem(item) {
      this.isLoading = true
      try {
        await axios.get(`${baseApiUrl}beneficiarios/${item.id}?access_token=${sessionStorage.getItem('accToken')}`).then(response => {
          if (response.data) {
            this.impressao = Object.assign({}, response.data)
            setTimeout(() => {
              if (this.programaId == '67acaf2503f5ac3477351a57') {
                PH.printElement(document.getElementById('printBeneficiário'))
              } else if (this.programaId == '67acaf2503f5ac3477351a57') {
                PH.printElement(document.getElementById('printBeneficiário'))
              }
              this.isLoading = false
            }, 50);
          }
        })
      } catch (error) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao imprimir. Tente novamente", "DESCULPE")
      }
    },

    async carregaCelulas() {
      await axios.get(baseApiUrl + 'Celulas?filter={"where":{"igrejaId":"' + this.user.igrejaId + '"}, "fields":{"nome": true, "id": true}, "order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.celulas = response.data
          }
        })
    },

    async carregaDados() {
      this.isLoading = true
      let url
      if (this.user.tipo == 'PROGRAMA') {
        url = 'Programas?filter={"where":{"and":[{"igrejaId":"' + this.user.igrejaId + '"},{"tipo":"EM"}]}}'
      } else {
        url = 'Programas?filter={"where":{"and":[{"igrejaId":"' + this.user.igrejaId + '"}]}}'
      }
      await axios.get(baseApiUrl + url + '&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.programas = response.data.sort(this.compare)
            if (!this.programaId && this.programas.length > 0) {
              this.programaId = this.programas[0].id
            }
            if (this.programaIdAtual)
              this.programaId = this.programaIdAtual
          } else {
            this.isLoading = false
          }
        })
      await this.carregaBeneficiarios()
    },

    async saveBeneficiary() {
      this.isLoading = true;
      const vm = this;

      if (!this.editedItem.membroId && this.editedIndex === -1) {
        this.isLoading = false;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Por favor, selecione um membro para cadastrar.", "ATENÇÃO");
        return;
      }

      if (!this.editedItem.dataInicioPrograma || !this.editedItem.dataFimPrograma) {
        this.isLoading = false;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Por favor, preencha as datas de início e fim do programa.", "ATENÇÃO");
        return;
      }

      const dataInicioFormatada = moment(this.editedItem.dataInicioPrograma, 'DD/MM/YYYY', true);
      const dataFimFormatada = moment(this.editedItem.dataFimPrograma, 'DD/MM/YYYY', true);

      if (!dataInicioFormatada.isValid() || !dataFimFormatada.isValid()) {
        this.isLoading = false;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Formato de data e hora inválido. Use DD/MM/YYYY", "ATENÇÃO");
        return;
      }
      if (dataInicioFormatada.isAfter(dataFimFormatada)) {
        this.isLoading = false;
        vm.$refs.chamaSnackbar.snack("#EF5350", "A data e hora de início não podem ser posteriores à data e hora de fim do programa.", "ATENÇÃO");
        return;
      }

      const beneficiarioData = {
        programaId: this.programaId,
        igrejaId: this.user.igrejaId,
      };

      if (this.editedIndex === -1) { // NOVO CADASTRO
        beneficiarioData.membroId = this.editedItem.membroId;
        beneficiarioData.nome = this.editedItem.nome;
        beneficiarioData.cpf = this.editedItem.cpf;
        beneficiarioData.sexo = this.editedItem.sexo;
        beneficiarioData.dataNascimento = moment(this.editedItem.dataNascimento, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
        beneficiarioData.celulaId = this.editedItem.celulaId;
        beneficiarioData.dataInicioPrograma = dataInicioFormatada.toISOString();
        beneficiarioData.dataFimPrograma = dataFimFormatada.toISOString();

      } else { // EDIÇÃO DE BENEFICIÁRIO EXISTENTE - Somente datas do programa são editáveis
        beneficiarioData.id = this.editedItem.id;
        beneficiarioData.dataInicioPrograma = dataInicioFormatada.toISOString();
        beneficiarioData.dataFimPrograma = dataFimFormatada.toISOString();
      }

      try {
        if (this.editedIndex > -1) {
          const response = await axios.patch(`${baseApiUrl}beneficiarios/${beneficiarioData.id}?access_token=${sessionStorage.getItem('accToken')}`, beneficiarioData);
          if (response.data) {
            vm.$refs.chamaSnackbar.snack("#0288D1", "Beneficiário atualizado com sucesso!", "INFORMAÇÃO");
          }
        } else {
          const existingBeneficiary = await axios.get(`${baseApiUrl}Beneficiarios?filter={"where":{"programaId":"${this.programaId}", "membroId":"${beneficiarioData.membroId}"}}&access_token=${sessionStorage.getItem('accToken')}`);
          if (existingBeneficiary.data && existingBeneficiary.data.length > 0) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Este membro já é um beneficiário deste programa.", "ERRO");
            return;
          }

          const response = await axios.post(`${baseApiUrl}beneficiarios?access_token=${sessionStorage.getItem('accToken')}`, beneficiarioData);
          if (response.data) {
            vm.$refs.chamaSnackbar.snack("#0288D1", "Beneficiário cadastrado com sucesso!", "INFORMAÇÃO");
          }
        }
        await this.carregaBeneficiarios();
        this.closeAddEdit();
      } catch (error) {
        // eslint-disable-next-line
        this.isLoading = false;
        const errorMessage = error.response && error.response.data && error.response.data.error && error.response.data.error.message
          ? error.response.data.error.message
          : "Erro ao realizar operação, tente novamente.";
        vm.$refs.chamaSnackbar.snack("#EF5350", errorMessage, "ERRO");
      }
    },

    compare(a) {
      const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY', true).format()
      const dataC = moment().format()

      let comparison = 0;
      if (dataC >= dataA)
        comparison = 1;
      else if (dataC < dataA)
        comparison = -1;
      return comparison;
    },

    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHour(data_hora) {
      if (!data_hora) return 'N/A';
      return moment(data_hora).format('DD/MM/YYYY');
    },

    formatDateBrz(date) {
      if (!date || typeof date !== 'string') return 'N/A';
      if (date.includes('-')) {
        const [year, month, day] = date.split('-');
        if (year && month && day) return `${day}/${month}/${year}`;
      } else if (date.includes('/')) {
        const partes = date.split('/');
        if (partes.length === 3) return date;
      }
      return 'N/A';
    },

    formatDatePadrao(date) {
      if (!date) return null
      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDateHora(date) {
      if (!date) return null
      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },

    async carregaBeneficiarios() {
      this.beneficiarios = [];
      this.isLoading = true;

      if (!this.programaId) {
        this.isLoading = false;
        return;
      }

      let filterString = `{"where":{"programaId":"${this.programaId}"}`;
      filterString += `, "order":"nome ASC", "include":"membro"}`;

      try {
        const response = await axios.get(baseApiUrl + `Beneficiarios?filter=${filterString}&access_token=${sessionStorage.getItem('accToken')}`);
        let beneficiariosProcessados = [];
        for (let i = 0; i < response.data.length; i++) {
          const beneficiarioApi = response.data[i];
          const membro = beneficiarioApi.membro || {};

          if (this.user.tipo === 'GERENTE' && membro.recadastramento !== true) {
            continue;
          }

          const nomeBeneficiario = beneficiarioApi.nome || membro.nome || 'N/A';
          const sexoBeneficiario = beneficiarioApi.sexo || membro.sexo || 'N/A';
          const celulaBeneficiario = membro.celulaId ? this.nomeCelula(membro.celulaId).trim() : 'N/A';

          beneficiariosProcessados.push({
            "nome": nomeBeneficiario,
            "cpf": beneficiarioApi.cpf || membro.cpf || 'N/A',
            "sexo": sexoBeneficiario,
            "dataNascimento": membro.dataNascimento ? this.formatDateBrz(membro.dataNascimento) : 'N/A',
            "idade": membro.dataNascimento ? this.calculaIdade(this.formatDateBrz(membro.dataNascimento)) : 'N/A',
            "created": beneficiarioApi.created,
            "createdFormatted": `${this.transformaData(beneficiarioApi.created, 'DD/MM/YYYY')} às ${this.transformaData(beneficiarioApi.created, 'HH:mm:ss')}`,
            "celula": celulaBeneficiario,
            "id": beneficiarioApi.id,
            "membroId": membro.id,
            "celulaId": membro.celulaId,
            "dataInicioPrograma": beneficiarioApi.dataInicioPrograma ? this.formatDateHour(beneficiarioApi.dataInicioPrograma) : 'N/A',
            "dataFimPrograma": beneficiarioApi.dataFimPrograma ? this.formatDateHour(beneficiarioApi.dataFimPrograma) : 'N/A',
          });
        }
        this.beneficiarios = beneficiariosProcessados;
        this.isLoading = false;
      } catch (error) {
        // eslint-disable-next-line
        this.isLoading = false;
      }
    },

    calculaIdade(dataNasc) {
      if (!dataNasc || dataNasc === 'N/A') return 'N/A';
      const [dia, mes, ano] = dataNasc.split('/').map(Number);
      const dataNascimento = new Date(ano, mes - 1, dia);
      const hoje = new Date();
      let idade = hoje.getFullYear() - dataNascimento.getFullYear();
      const m = hoje.getMonth() - dataNascimento.getMonth();
      if (m < 0 || (m === 0 && hoje.getDate() < dataNascimento.getDate())) {
        idade--;
      }
      return idade;
    },

    nomeCelula(celulaId) {
      const celulaEncontrada = this.celulas.find(celula => celula.id === celulaId);
      return celulaEncontrada ? celulaEncontrada.nome : 'N/A';
    },

    async realizaCheckin() {
      this.loading = true
      await axios.post(`${baseApiUrl}beneficiarios/checkin?access_token=${sessionStorage.getItem('accToken')}`, this.checkin)
        .then(res => {
          if (res.data != '') {
            switch (res.data.codigo) {
              case 3:
                this.loading = false
                this.close()
                var vm = this
                vm.$refs.chamaSnackbar.snack("#0288D1", "Checkin realizado com sucesso!", "INFORMAÇÃO")
                break;
              case 1:
                this.close()
                vm = this
                vm.$refs.chamaSnackbar.snack("#0288D1", "Checkin já realizado!", "INFORMAÇÃO")
                this.loading = false
                break;
              default:
                break;
            }
          } else {
            vm = this
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
        })
      await this.carregaBeneficiarios()
      this.checkin.cod_beneficiario = ''
      this.checkin.tipo = ''
      this.checkin.programaId = ''
      this.checkin.userValidatorId = ''
    },

    openDialog(item) {
      this.checkin.cod_incricao = item.cod_incricao
      this.checkin.tipo = 'CHECKIN'
      this.checkin.programaId = this.programaId
      this.checkin.userValidatorId = this.user.id
      this.nome = item.nome
      this.dialog = true
    },

    async editItem(item) {
      this.isLoading = true;
      this.editedIndex = this.beneficiarios.indexOf(item);

      try {
        const response = await axios.get(`${baseApiUrl}beneficiarios/${item.id}?filter={"include":"membro"}&access_token=${sessionStorage.getItem('accToken')}`);
        if (response.data) {
          const beneficiarioCompleto = response.data;
          const membro = beneficiarioCompleto.membro || {};

          this.editedItem = {
            id: beneficiarioCompleto.id,
            nome: beneficiarioCompleto.nome,
            cpf: membro.cpf || '',
            sexo: beneficiarioCompleto.sexo || membro.sexo || '',
            dataNascimento: membro.dataNascimento ? this.formatDateBrz(membro.dataNascimento) : '',
            celulaId: beneficiarioCompleto.celulaId || membro.celulaId || '',
            membroId: membro.id,
            membro: membro,
            dataInicioPrograma: beneficiarioCompleto.dataInicioPrograma ? this.formatDateHour(beneficiarioCompleto.dataInicioPrograma) : '',
            dataFimPrograma: beneficiarioCompleto.dataFimPrograma ? this.formatDateHour(beneficiarioCompleto.dataFimPrograma) : '',
          };
          this.addUser = true;
          this.isLoading = false;
          this.membroSelecionado = null;
          this.membroEncontradoMensagem = '';
          this.membroEncontradoSucesso = false;
        }
      } catch (error) {
        // eslint-disable-next-line
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Problema encontrado ao editar beneficiário", "DESCULPE");
      }
    },

    deleteItem(item) {
      var r = confirm('Deseja realmente excluir: ' + item.nome + ' do programa?')
      if (r == true) {
        this.isLoading = true
        axios.delete(`${baseApiUrl}Beneficiarios/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
          .then(() => {
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaBeneficiarios()
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          })
      }
    },

    close() {
      this.dialog = false
    },

    closeAddEdit() {
      this.addUser = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.membroSelecionado = null;
        this.membrosRecadastrados = [];
        this.membroEncontradoMensagem = '';
        this.membroEncontradoSucesso = false;
      }, 300);
    },

    transformaData(data, formato) {
      let date = moment(data).format(formato);
      return date
    },

    async seeItem(item) {
      this.isLoading = true
      try {
        const response = await axios.get(`${baseApiUrl}beneficiarios/${item.id}?filter={"include":"membro"}&access_token=${sessionStorage.getItem('accToken')}`);
        if (response.data) {
          const beneficiarioCompleto = response.data;
          const membro = beneficiarioCompleto.membro || {};

          let paiResponse = { data: null };

          if (membro.paiId) {
            paiResponse = await axios.get(baseApiUrl + 'Membros/' + membro.paiId + '?access_token=' + sessionStorage.getItem('accToken'));
          }
          const nomeBeneficiario = beneficiarioCompleto.nome || membro.nome || 'N/A';
          const sexoBeneficiario = beneficiarioCompleto.sexo || membro.sexo || 'N/A';
          const dataNascimentoBeneficiario = membro.dataNascimento ? this.formatDateBrz(membro.dataNascimento) : 'N/A';
          const celulaBeneficiario = membro.celulaId ? this.nomeCelula(membro.celulaId).trim() : 'N/A';
          const idadeBeneficiario = membro.dataNascimento ? this.calculaIdade(this.formatDateBrz(membro.dataNascimento)) + ' anos' : 'N/A';

          let dados = {
            "nome": nomeBeneficiario,
            "sexo": sexoBeneficiario,
            "dataNascimento": dataNascimentoBeneficiario,
            "celula": celulaBeneficiario,
            "idade": idadeBeneficiario,
            "celulaPai": paiResponse.data && paiResponse.data.celulaId ? this.nomeCelula(paiResponse.data.celulaId).trim() : 'N/A',
            "id": beneficiarioCompleto.id,
            "dataInicioPrograma": beneficiarioCompleto.dataInicioPrograma ? this.formatDateHour(beneficiarioCompleto.dataInicioPrograma) : 'N/A',
            "dataFimPrograma": beneficiarioCompleto.dataFimPrograma ? this.formatDateHour(beneficiarioCompleto.dataFimPrograma) : 'N/A',
          }
          this.editedItem = Object.assign({}, dados)
          this.dialogoDadosInscricao = true
          this.isLoading = false
        }
      } catch (error) {
        // eslint-disable-next-line
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Problema encontrado ao visualizar beneficiário", "DESCULPE")
      }
    },

    criarNovo() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.membroEncontradoMensagem = '';
      this.membroEncontradoSucesso = false;
      this.addUser = true;
      this.membroSelecionado = null;
      this.carregaMembrosRecadastrados();
    },

    async carregaMembrosRecadastrados() {
      this.isLoading = true;
      try {
        const filter = {
          where: {
            igrejaId: this.user.igrejaId,
            recadastramento: true
          },
          order: 'nome ASC'
        };
        const response = await axios.get(`${baseApiUrl}Membros?filter=${encodeURIComponent(JSON.stringify(filter))}&access_token=${sessionStorage.getItem('accToken')}`);
        this.membrosRecadastrados = response.data || [];
      } catch (error) {
        // eslint-disable-next-line
        this.membrosRecadastrados = [];
        this.membroEncontradoMensagem = 'Erro ao carregar lista de membros recadastrados.';
        this.membroEncontradoSucesso = false;
      } finally {
        this.isLoading = false;
      }
    },

    selecionarMembroAutocomplete(membro) {
      if (!membro) {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.membroEncontradoMensagem = '';
        this.membroEncontradoSucesso = false;
        return;
      }
      this.editedItem.nome = membro.nome;
      this.editedItem.cpf = membro.cpf;
      this.editedItem.sexo = membro.sexo;
      this.editedItem.dataNascimento = membro.dataNascimento ? this.formatDateBrz(membro.dataNascimento) : 'N/A';
      this.editedItem.celulaId = membro.celulaId;
      this.editedItem.membroId = membro.id;
      this.editedItem.membro = membro;
      this.membroEncontradoMensagem = `Membro selecionado: ${membro.nome} (CPF: ${membro.cpf}).`;
      this.membroEncontradoSucesso = true;
    },

    customFilter(item, queryText, itemText) {
      const text = ((itemText || '') + ' ' + (item.cpf || '')).toLowerCase();
      const searchText = queryText.toLowerCase();
      return text.includes(searchText);
    },
  },
}
</script>

<style>
.textoUser {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.cssBotao {
  font-weight: bold;
  border-radius: 8px;
  width: 150px;
  font-size: 7px;
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style>
